const {abstractResource} = require("./abstractResource");

const service = abstractResource("EVENT");

const Event = {
    ...service('events'),

    get_form(){
        return{
            title: null,
            description: null,
            status: null,
            start: null,
            end: null,
            location: null,
            base_url: 'https://calendar.staging.heedesk.io/v1/',
            source: "event",
            type: "events",
            link: "b",
        }
    }
}

const Task = {
    ...service('tasks'),

    get_form(){
        return{
            title: null,
            description: null,
            finished: false,
            date: null,
            assigned_user: null,
            external_id: null,
        }
    }
}

module.exports = {
    Event,
    Task,
}